import { useTranslation } from 'react-i18next'

import { useCloseConfirm } from '../../../../../Form'
import { FormikForm } from '../../../../../Formik'
import { WidgetFormContainer } from '../../../../../Widget'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { useApplicantBlockSave } from '../../RentalPortalApplicantProfileTabOverview.hooks'
import { APPLICANT_IDENTITY_DISCARD_CONFIRMATION_PROPS } from '../ApplicantIdentityWidget.constants'
import {
  getApplicantIdentityInitialValues,
  getApplicantIdentityPatchPayload,
  getApplicantIdentityValidationSchema,
} from '../ApplicantIdentityWidget.utils'

import { ApplicantIdentityWidgetFormFields } from './ApplicantIdentityWidgetFormFields'

function ApplicantIdentityWidgetForm({ onClose, onSuccess }) {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const {
    handleAddNotification,
    handleRemoveNotification,
    handleSaveBlock,
    notifications,
  } = useApplicantBlockSave({ onClose, onSuccess })

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  function handleSubmit(values, formikHelpers) {
    handleSaveBlock({
      formikHelpers,
      payload: getApplicantIdentityPatchPayload({ applicantData, values }),
    })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        confirmationProps: APPLICANT_IDENTITY_DISCARD_CONFIRMATION_PROPS,
        isCloseConfirm,
        setCloseConfirm,
        onClose,
      }}
      initialValues={getApplicantIdentityInitialValues(applicantData)}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getApplicantIdentityValidationSchema(t)}
      onSubmit={handleSubmit}
    >
      <ApplicantIdentityWidgetFormFields
        isCloseConfirm={isCloseConfirm}
        notifications={notifications}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ApplicantIdentityWidgetForm
